import { createThirdwebClient } from 'thirdweb'
import staticConfig from 'src/config'

export const thirdwebClient = createThirdwebClient({
  clientId: staticConfig.thirdWebClientId,
})
